import { render, staticRenderFns } from "./SetReserveResource.vue?vue&type=template&id=8cdde9de&"
import script from "./SetReserveResource.vue?vue&type=script&lang=js&"
export * from "./SetReserveResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports